export const enum ThemeType {
    LIGHT = 'light',
    DARK = 'dark',
}